export default __webpack_public_path__ + "static/media/datavolo.64dceb03.png";